// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bia_wx bia_jb bia_xl bia_i bia_j bia_q bia_vt bia_et bia_so bia_sp bia_eg","CommentsButton__icon":"il_b bia_rz"};